import { CSSProperties } from "@material-ui/styles";
import { ReactNode } from "react";

const MessageBox = (props: {children: ReactNode, error?: boolean, className?: string, style?: CSSProperties}) => 
    <div 
        className={"MessageBox " + (props.className ?? '') + (props.error ? 'error-msg' : '')}
        style={props.style}
    >{props.children}</div>

export default MessageBox;